import { Component } from "react";
import AppHeaderBean from "../data/bean/app_header_bean";
import CertificateCollectionStatusWebServices from "../service/certificate_collection_status_web_service";
import AuthBloc from "./auth_bloc";

class CertificateCollectionStatusDetailBloc extends Component {
  static getDummyUserData() {
    return new AppHeaderBean(
      "Janice Wong",
      "Premier Financial Manager",
      "HSBC Amanah Takaful"
    );
  }

  static getUserData(name, role, branch) {
    return new AppHeaderBean(name, role, branch);
  }

  static async getCertificateCollectionDetail(entity, recMap) {
    let token = "";
    let result = {};
    const session = await AuthBloc.checkSession();

    if (session) {
      token = session.accessToken;
    }

    let response =
      await CertificateCollectionStatusWebServices.getCertificateCollectionDetail(
        token,
        entity,
        recMap
      );

    if (response.success) {
      result = response.data;
    }
    return result;
  }
}

export default CertificateCollectionStatusDetailBloc;
